
import Vue from 'vue';
import ConfirmReasonModal from '../confirm-reason-modal/confirm-reason-modal.vue';
import { DateFormatting } from '@sageworks/core-logic';
import { ApplicationDocumentRequest } from '@sageworks/jpi';

export default Vue.extend({
	name: 'BorrowerNotUploadingReasonModal',
	components: { ConfirmReasonModal },
	props: {
		isLender: Boolean,
		documentRequestId: Number,
		documentName: String,
		notUploadedReason: String,
		documentNamesId: Number
	},
	computed: {
		isInvalidTemplateStatus(): boolean {
			return (
				this.esignTemplateStatus === 'NOT_A_VALID_ADOBE_TEMPLATE' ||
				this.esignTemplateStatus === 'NOT_A_VALID_DOCUSIGN_TEMPLATE'
			);
		},
		modalId(): string {
			return `borrowerNotUploadingReasonModal-${this.documentRequestId}`;
		},
		reasonId(): string {
			return `viewReason-${this.documentRequestId}`;
		},
		truncateReason(): string {
			let truncatedReason = this.notUploadedReason;
			if (truncatedReason.length > 40) {
				truncatedReason = truncatedReason.substring(0, 39) + '...';
			}
			return truncatedReason;
		},
		reasonForNotUploadingText(): string {
			if (this.isInvalidTemplateStatus || this.esignTemplateStatus === '') {
				return 'If you are unable to upload this document at this time, please provide an explanation below:';
			}
			return 'If you are unable to sign this document at this time, please provide an explanation below:';
		},
		reasonErrorMessageText(): string {
			if (this.isInvalidTemplateStatus || this.esignTemplateStatus === '') {
				return 'Please enter an explanation for why you are unable to upload this document at this time';
			}
			return 'Please enter an explanation for why you are unable to sign this document at this time';
		},
		esignTemplateStatus(): string | undefined {
			const statusMap = this.directStore.state.ESignModule.esignTemplateStatuses;
			return statusMap.get(this.documentRequestId);
		},
	},
	methods: {
		saveReason({ reason }: { reason: string }) {
			this.directStore.dispatch.ApplicationDocumentRequest.patchApplicationDocumentRequest({
				id: this.documentRequestId,
				documentRequestProperties: { 
					notUploadedReason: reason,
					dateUploaded: DateFormatting.formatDateForJpi(new Date()),
					uploadedByUsersId: this.directStore.state.User.user?.id,
					uploadedByUserType: ApplicationDocumentRequest.UploadedByUserTypeEnum.BankCustomerUser
				}
			});
		},
	}
});
